<template>
  <div>
    <div
      v-if="withText"
      class="columns text-center"
    >
      <div class="column">
        <div class="title is-5 has-text-primary uppercase mb-2">
          Extrémité A
        </div>
        {{ extremiteA }}
      </div>
      <div class="column">
        <div class="title is-5 has-text-primary uppercase mb-2">
          Type de gaine
        </div>
        <div v-if="typeDeGaine">
          <div class="mb-2">
            {{ typeDeGaine }}
          </div>
          <div
            v-if="withDetails"
            class="is-size-6"
          >
            {{ caracteristiquesGaines[typeDeGaine]['description'] }}
          </div>
        </div>
        <div v-if="!mode">
          <div class="mb-2">
            Séléctionnez vos paramètres pour commencer votre configuration.
          </div>
        </div>
      </div>
      <div class="column">
        <div class="title is-5 has-text-primary uppercase mb-2">
          Extrémité B
        </div>
        {{ extremiteB }}
      </div>
    </div>

    <div class="is-flex">
      <div
        v-if="extremiteA"
        class="is-flex flex-column w-1/3"
      >
        <div class="is-flex align-items-center">
          <BaseConnector
            v-if="extremiteA"
            width="300px"
            :os2="isOs2"
            :type="extremiteA"
          />
          <div
            :class="mode"
            class="trait-horizontal left-margin flex-grow-1"
          />
        </div>
        <div
          v-if="nombreDeBrins"
          class="ml-4 text-center"
        >
          {{ nombreDeBrins }} brins
        </div>
        <div class="is-flex align-items-center">
          <BaseConnector
            v-if="extremiteA"
            width="300px"
            :os2="isOs2"
            :type="extremiteA"
          />
          <div
            :class="mode"
            class="trait-horizontal left-margin flex-grow-1"
          />
        </div>
      </div>
      <div class="is-flex flex-grow-1 relative align-items-center p-0">
        <div
          v-if="extremiteA"
          :class="mode"
          class="trait-vertical vertical-left trait-haut"
        />
        <div class="flex-grow-1">
          <div
            :class="mode"
            class="big-trait-horizontal right-margin mb-1"
          />
          <div
            :class="mode"
            class="big-trait-horizontal right-margin"
          />
        </div>
        <div
          v-if="extremiteA"
          :class="mode"
          class="trait-vertical vertical-left trait-bas"
        />
        <!-- <Gaine width="200px" /> -->
        <img
          :src="require(`@/components/connectors/gaine.png`)"
          alt=""
        >
        <div
          v-if="extremiteB"
          :class="mode"
          class="trait-vertical vertical-right trait-haut"
        />
        <div class="flex-grow-1">
          <div
            :class="mode"
            class="big-trait-horizontal mb-1"
          />
          <div
            :class="mode"
            class="big-trait-horizontal"
          />
        </div>
        <div
          v-if="extremiteB"
          :class="mode"
          class="trait-vertical vertical-right trait-bas"
        />
      </div>
      <div
        v-if="extremiteB"
        class="is-flex flex-column min-width align-items-end w-1/3"
      >
        <div class="is-flex flex-row-reverse align-items-center">
          <BaseConnector
            v-if="extremiteB"
            width="300px"
            :os2="isOs2"
            reversed
            :type="extremiteB"
          />
          <div
            :class="mode"
            class="trait-horizontal flex-grow-1"
          />
        </div>
        <div
          v-if="nombreDeBrins"
          class="mr-4 text-center"
        >
          {{ nombreDeBrins }} brins
        </div>
        <div class="is-flex flex-row-reverse align-items-center">
          <BaseConnector
            v-if="extremiteB"
            width="300px"
            :os2="isOs2"
            reversed
            :type="extremiteB"
          />
          <div
            :class="mode"
            class="trait-horizontal flex-grow-1"
          />
        </div>
      </div>
    </div>
    <div
      v-if="longueur && withText"
      class="column text-center mt-8"
    >
      <div class="title is-5 has-text-primary uppercase mb-2">
        Longueur du lien
      </div>
      <div>
        {{ longueur }} mètres
      </div>
    </div>
  </div>
</template>

<script>
import BaseConnector from '@/components/BaseConnector.vue';
import { CARACTERISTIQUES_GAINES } from '@/constants.js';
import Gaine from '@/components/connectors/gaine.svg';

export default {
  name: 'TrunkVisual',
  components: { BaseConnector, Gaine },
  props: {
    extremiteA: {
      type: String,
      default: undefined,
    },
    extremiteB: {
      type: String,
      default: undefined,
    },
    mode: {
      type: String,
      default: undefined,
    },
    typeDeGaine: {
      type: String,
      default: undefined,
    },
    nombreDeBrins: {
      type: Number,
      default: undefined,
    },
    withText: {
      type: Boolean,
      default: true,
    },
    withDetails: {
      type: Boolean,
      default: true,
    },
    longueur: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      caracteristiquesGaines: CARACTERISTIQUES_GAINES,
    };
  },
  computed: {
    isOs2() {
      return this.mode === 'OS2';
    },
  },
};
</script>

<style lang="scss" scoped>
.radius-left {
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}

.radius-right {
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}

.left-margin {
  margin-left: -1px;
}

.right-margin {
  margin-right: -1px;
}

.trait-horizontal {
  height: 7px;
}

.big-trait-horizontal {
  height: 7px;
  border-radius: 3px;
}

.trait-vertical {
  width: 7px;
  position: absolute;
  border-radius: 3px;
}

.vertical-left {
  margin-left: -4px;
}

.vertical-right {
  right: 0px;
  margin-right: -4px;
}

.trait-haut {
  height: 35px;
  margin-top: -38px;
}

.trait-bas {
  height: 34px;
  margin-top: 38px;
}

.flex-column {
  flex-direction: column;
}

.flex-grow-1 {
  flex-grow: 1;
}

.align-items-center {
  align-items: center;
}

.OM1 {
  background-color: #f08b04;
}

.OM2 {
  background-color: #f08b04;
}

.OM3 {
  background-color: #8edadb;
}

.OM4 {
  background-color: #ed61ac;
}

.OM5 {
  background-color: #3d9370;
}

.OS2 {
  background-color: #ffd92e;
}

svg {
  overflow: visible;
}
</style>
